import { CF } from '@dadohr/shared/versions';
import { callFirebaseFunction } from '../../../services/firebaseFunctions';

export const sendToSlackLog = (slackExperienceMessageResponseId: string) => {
  return callFirebaseFunction(CF.slack.sendToLog, {
    id: slackExperienceMessageResponseId
  });
};
